module.exports = "<div class=\"actionsheet-overlay\">\n  <div class=\"actionsheet\">\n    <div class=\"actionsheet-body\">\n    </div>\n  </div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./template.html
 ** module id = 15
 ** module chunks = 0
 **/